import { render, staticRenderFns } from "./a-search-icon.vue?vue&type=template&id=483f4202&"
import script from "./a-search-icon.vue?vue&type=script&lang=js&"
export * from "./a-search-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports